var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',{staticClass:"border p-2",attrs:{"id":"narbarmenu"}},[_c('div',{on:{"click":_vm.isclicked}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }